/**
* Usave
    Usage:
    import { useAppStateStore } from '@/stores/AppStateStore.js'

    const appStateStore = useAppStateStore();

    // Trigger an action in AppStateStore
    appStateStore.triggerTimeTrackingEntriesReload();
    // Or pass a value to an action
    appStateStore.setBottomRightToolbarMinimized(true)

    // Watch a state in AppStateStore
    watch(() => appStateStore.reloadTimeTrackingEntriesFlag, () => {
        loadEntries();
    });

 */

import { defineStore } from 'pinia';

const getStoredBottomRightToolbarMinimized = () => {
    if (typeof window === 'undefined') {
        return false;
    }

    return window.localStorage.getItem('toolbarMinimized') === 'true';
};

const storeBottomRightToolbarMinimized = (value) => {
    if (typeof window === 'undefined') {
        return;
    }

    window.localStorage.setItem('toolbarMinimized', value);
};

export const useAppStateStore = defineStore(
    'appStateStore',
    {
        state: () => ({
            reloadTimeTrackingEntriesFlag: false,
            bottomRightToolbarMinimized: getStoredBottomRightToolbarMinimized(),
        }),
        actions: {
            triggerTimeTrackingEntriesReload() {
                this.reloadTimeTrackingEntriesFlag = !this.reloadTimeTrackingEntriesFlag;
            },
            setBottomRightToolbarMinimized(value) {
                this.bottomRightToolbarMinimized = value;
                storeBottomRightToolbarMinimized(value);
            },
            toggleBottomRightToolbarMinimized() {
                this.setBottomRightToolbarMinimized(!this.bottomRightToolbarMinimized);
            },
        },
    }
);
